import React from 'react';
import ProfileMenu from './ProfileMenu';
import { URL } from '../variables';
import { connect } from 'react-redux';
import { languages, languageOptions, getSelectedLanguage, setSelectedLanguage } from '../languages';


class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            theme: 'light',
            selectedLanguage: getSelectedLanguage()
        }
    }

    componentDidMount() {
        localStorage.setItem('correcao_theme', 'light');
        document.body.classList.remove('correcao-dark-theme');
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('correcao_language_change', this.languageListener);
    }

    componentWillUnmount() {
        if (this.languageListener) {
            window.removeEventListener('correcao_language_change', this.languageListener);
        }
    }

    changeLanguage(event) {
        let selectedLanguage = setSelectedLanguage(event.target.value);
        this.setState({ selectedLanguage });
    }

    render() {
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        let logoSrc = this.props.faculdade.logo;
        return (
            <div className="topbar correcao-app-header">

                <div className="topbar-left correcao-header-brand">
                    {this.props.faculdade.logo != null && <a className="logo correcao-header-logo">
                        <span>
                            <img src={logoSrc} alt="" height='70' />
                        </span>
                        <i>
                            <img className="img-fluid" src={logoSrc} alt="" style={{height:70,objectFit:'contain'}} />
                        </i>
                    </a>}
                </div>
                <nav className="navbar-custom correcao-header-nav">
                    <ul className="navbar-right correcao-header-actions d-flex list-inline float-right mb-0">
                        <li className="list-inline-item">
                            <label className="correcao-preference-select compact">
                                <i className="mdi mdi-web"></i>
                                <select value={this.state.selectedLanguage} onChange={this.changeLanguage.bind(this)} aria-label={t.language_label} title={t.language_label}>
                                    {languageOptions.map((item) => <option key={item.value} value={item.value}>{item.value}</option>)}
                                </select>
                            </label>
                        </li>
                        <ProfileMenu />


                    </ul>



                </nav>
            </div>

        );
    }


}

const mapsStateToProps = (state) => (
    {
        faculdade: state.AppReducer.faculdade
    }
);

export default connect(mapsStateToProps, {})(Header);
